import { BatchPreviewTable } from "../batch-preview-table";
import { BatchPreviewTransitionPage } from "../batch-preview-transition-page";

import { useBatchPreviewObservationTransitionPage } from "./batch-preview-observation-transition-page.hook";

export const BatchPreviewObservationTransitionPage = () => {
  const { observations, loading, columns } =
    useBatchPreviewObservationTransitionPage();

  return (
    <BatchPreviewTransitionPage model="observation">
      <BatchPreviewTable
        model="observation"
        items={observations}
        loading={loading}
        columns={columns}
      />
    </BatchPreviewTransitionPage>
  );
};
